export const apiBaseUrl = process.env.REACT_APP_STUDIO_URL;
export const apiBackendBaseUrl = process.env.REACT_APP_STUDIO_BACKEND_API_URL;
export const createFolderUrl = process.env.REACT_APP_CREATE_FOLDER;
export const getAllExistingFlow = process.env.REACT_APP_GETALL_EXISTING_FLOW;
export const getFileUserFlow = process.env.REACT_APP_GETFILE_USERFLOW;
export const createFileUrl = process.env.REACT_APP_CREATE_FLOW;
export const deleteFolderUrl = process.env.REACT_APP_DELETE_FOLDER;
export const detachFlow = process.env.REACT_APP_DETACH_FLOW;
export const reorder = process.env.REACT_APP_REORDER_FLOW_AND_COLLECTION;
export const deleteFlowUrl = process.env.REACT_APP_DELETE_FLOW;
export const renameFolderUrl = process.env.REACT_APP_RENAME_FOLDER;
export const apiConnectorMetadata = process.env.REACT_APP_APICONNECTOR_NODE_METADATA;
export const renameFlowUrl = process.env.REACT_APP_RENAME_FLOW;
export const saveUserflow = process.env.REACT_APP_SAVE_USERFLOW;
export const subscriptionOffers = process.env.REACT_APP_SUBSCRIPTION_OFFERS;
export const enablesubscriptionoffers = process.env.REACT_APP_ENABLE_SUBSCRIPTION_OFFERS
export const duplicateFlowUrl = process.env.REACT_APP_CREATE_DUPLICATE_FLOW;
export const resourceApiDbData = process.env.REACT_APP_RESOURCES_EDITOR_API_DB_DATA;
export const getAllParamters = process.env.REACT_APP_GET_ALL_PARAMETERS;
export const resourceApiDbTableData = process.env.REACT_APP_RESOURCES_EDITOR_API_DB_TABLE_DATA;
export const resourceConfigDtls = process.env.REACT_APP_RESOURCES_CONFIG_DETAILS;
export const getEnvironmentVariable = process.env.REACT_APP_GET_ENVIRONMENT_VARIABLE;
export const pageNameApi = process.env.REACT_APP_PAGENAME;
export const pageNameDetails = process.env.REACT_APP_PAGENAME_DETAILS;
export const getEmailMetaData = process.env.REACT_APP_GET_EMAIL_METADATA;
export const fetchtestvalue = process.env.REACT_APP_FETCH_TEST_VALUE;
export const executiondtls = process.env.REACT_APP_GET_EXECUTION_DTLS;
export const multipartexecutiondtls = process.env.REACT_APP_GET_MULTIPART_EXECUTION_DTLS;
export const exportFile = process.env.REACT_APP_GET_EXPORT_EXECU_DWNLD;
export const fetchExecutionLogs = process.env.REACT_APP_FETCH_EXECUTION_LOG_NAMES;
export const fetchExecutionLogById = process.env.REACT_APP_FETCH_EXECUTION_LOG_NAMESID;
export const fetchOpenAIDtls = process.env.REACT_APP_FETCH_OPENAI_DETAILS;
export const fetchMiniAppMetaData = process.env.REACT_APP_FETCH_MINIAPP_METADATA;
export const deleteValidationApi = process.env.REACT_APP_DELETE_VALIDATION;
export const getMediaAssetDetails = process.env.REACT_APP_GET_MEDIA_ASSETS_DETAILS;
export const getMediaAssetObjectDetails = process.env.REACT_APP_GET_MEDIA_ASSETS_OBJECT_DETAILS;
export const studiotracelog = process.env.REACT_APP_STUDIO_TRACE_LOG;
export const getworkspaceurl = process.env.REACT_APP_GET_WORKSPACE;
export const workspacedetailsurl = process.env.REACT_APP_WORKSPACE_DETAILS;
export const createWorkSpaceUrl = process.env.REACT_APP_CREATE_WORKSPACE;
export const editWorkSpaceUrl = process.env.REACT_APP_EDIT_WORKSPACE;
export const deleteWorkSpaceUrl = process.env.REACT_APP_DELETE_WORKSPACE;
export const createAppUrl = process.env.REACT_APP_CREATE_APP;
export const deleteAppUrl = process.env.REACT_APP_DELETE_APP;
export const copyAppUrl = process.env.REACT_APP_COPY_APP;
export const editappnameurl = process.env.REACT_APP_EDIT_APPNAME;
export const dragworkspaceurl = process.env.REACT_APP_DRAG_WORKSPACE;
export const dashboardUrl = process.env.REACT_APP_DASHBOARD;
export const resourceEditorCallBack = process.env.REACT_APP_CALLBACK;
export const botResponse= process.env.REACT_APP_CHAT_BOT_RESPONSE;
export const chatbotDocumentUrl= process.env.REACT_APP_CHAT_BOT_DOCUMENT_UPLOAD;
export const chatbotGetDocument= process.env.REACT_APP_CHAT_BOT_GETS_DOCUMENT;
export const chatbotGetUrls= process.env.REACT_APP_CHAT_BOT_GETS_URLS;
export const chatbotDataDelete= process.env.REACT_APP_CHAT_BOT_DATA_DELETE;
export const popularAppTemplatesUrl = process.env.REACT_APP_POPULAR_APP_TEMPLATES;
export const pubLishAppTemplateUrl = process.env.REACT_APP_PUBLISH_APP_TEMPLATE;
export const addAppTemplateUrl = process.env.REACT_APP_ADD_APP_TEMPLATE;
export const appTemplateListUrl = process.env.REACT_APP_APP_TEMPLATE_LIST;
export const viewMoreAppTemplateUrl = process.env.REACT_APP_APP_TEMPLATE_VIEW_MORE;
export const getAllappTemplatesDtls = process.env.REACT_APP_GETALLAPPTEMPLATESDTLS;
export const getAppTemplateByGroupName = process.env.REACT_APP_APPTEMPLATEBYGROUPNAME;
export const searchApplicationTemplate =process.env.REACT_APP_SEARCHAPPLICATIONTEMPLATE;
export const rearrangedAppTemplateIdUrl = process.env.REACT_APP_REARRANGED_APPTEMPLATEGROUP;
export const updateLookupDataUrl = process.env.REACT_APP_UPDATE_LOOKUPDATA;
export const appTemplateListView = process.env.REACT_APP_APPTEMPLATELISTVIEW;
export const deleteAppTemplateUrl = process.env.REACT_APP_DELEAPPTEMPLATEBYID;
export const searchpagesectiontemplate = process.env.REACT_APP_SEARCHPAGESECTIONTEMPLATE;
export const searchpagetemplate = process.env.REACT_APP_SEARCHPAGETEMPLATE;
export const dragApptemplatePositionsUrl = process.env.REACT_APP_DRAGAPPTEMPLATEPOSITIONS;
export const appTemplateCategoryListUrl = process.env.REACT_APP_APPTEMPLATE_DEFAULT_CATEGORYLIST;
export const workspaceUserEvent = process.env.REACT_APP_WORKSPACE_USEREVENT;
export const eventapi = process.env.REACT_APP_EVENT_API;
export const tourGuideApi= process.env.REACT_APP_TOUR_GUIDE_API;
export const planDetailsApi= process.env.REACT_APP_SUBSCRIPTION_PLAN_DETAIL;
export const isEnableSubscription= process.env.REACT_APP_IS_ENABLE_SUBSCRIPTION;
export const getBillingDetails=process.env.REACT_APP_GET_BILLING_DETAILS;
export const updateBillingDetails=process.env.REACT_APP_UPDATE_BILLING_DETAILS;
export const getSubcriptionHistory= process.env.REACT_APP_GET_SUBSCRIPTION_HISTORY;
export const getInvoiceDetails=process.env.REACT_APP_GET_INVOICE_DETAILS;
export const getpaymentDetails=process.env.REACT_APP_GET_PAYMENT_DETAILS;
export const downloadPaymentReceiptApi=process.env.REACT_APP_DWNLD_PAYMENT_DETAILS;
export const viewInvoiceDetails=process.env.REACT_APP_VIEW_INVOICE_DETAILS
export const getAccountInfo = process.env.REACT_APP_GET_ACCOUNT_INFO;
export const getSubscriptionPopupInfo=process.env.REACT_APP_GET_SUBSCRIPTION_POPUP_INFO;
export const changePlan = process.env.REACT_APP_CHANGE_PLAN;
export const changePlanByAdmin = process.env.REACT_APP_CHANGE_PLAN_ADMIN;
export const changeAddon = process.env.REACT_APP_CHANGE_ADDON;
export const initiatePayment= process.env.REACT_APP_INITIATE_PAYMENT;
export const verifyPayment= process.env.REACT_APP_VERIFY_PAYMENT;
export const addPayment= process.env.REACT_APP_ADD_PAYMENT;
export const undeployUrl = process.env.REACT_APP_UNDEPLOY_USER_APP;
export const getPaymentUserDetail = process.env.REACT_APP_GET_USERDETAIL_FOR_PAYMENT_LINK;
export const generatePaymentLink = process.env.REACT_APP_GENERATE_PAYMENT_LINK;
export const applyDiscountApi = process.env.REACT_APP_APPLY_DISCOUNT_LINK;
export const generatePaymentLinkAuthorisedIds = process.env.REACT_APP_GENERATE_PAYMENTLINK_AUTHORISED_IDS;
export const getPaymentDetail=process.env.REACT_APP_PAYMENT_USER_DETAIL
export const verifyInitiatePayment=process.env.REACT_APP_VERIFY_INITIATE_PAYMENT
export const cancelSubscription=process.env.REACT_APP_CANCEL_SUBSCRIPTION
export const cancelSubscriptionbyadmin=process.env.REACT_APP_CANCEL_SUBSCRIPTION_BY_ADMIN
export const importFlowFromWorkspace= process.env.REACT_APP_IMPORT_FLOW_FROM_WORKSPACE;
export const getExecutionLogsByAppId = process.env.REACT_APP_GET_EXECUTIONLOGS_BY_APPID;
export const getDeletedFlows = process.env.REACT_APP_GET_DELETEDFLOWS;
export const restoreSelectedFlow = process.env.REACT_APP_RESTORE_SELECTED_FLOWS;
export const generateAppMovementAuthorisedIds = process.env.REACT_APP_GENERATE_APP_MOVEMENT_AUTHORISED_IDS;
export const getworkspacesforuser = process.env.REACT_APP_GET_WORKSPACES_FOR_USER;
export const gettenantandworkspacesforemail = process.env.REACT_APP_GET_WORKSPACES_FOR_EMAIL;
export const moveapplication = process.env.REACT_APP_MOVE_APPLICATION;
/**
 * Page editor Api Url
 */
export const createWidgetDetailsUrl = process.env.REACT_APP_CREATE_WIDGET_DETAILS;
export const getPageWidgetDetailsAndPropsWithPageId =
  process.env.REACT_APP_GET_PAGE_WIDGET_DETAILSANDPROPS_WITH_PAGEID;
export const updatePageWidgetDetails = process.env.REACT_APP_UPDATE_PAGE_WIDGET_DETAILS;
export const getApplicationDetailsUrl = process.env.REACT_APP_GET_APPLICATION_DETAILS;
export const createPageDetailsUrl = process.env.REACT_APP_CREATE_PAGE_DETAILS;
export const deletePageDetailsUrl = process.env.REACT_APP_DELETE_PAGE_DETAILS;
export const updatePageDetailsUrl = process.env.REACT_APP_UPDATE_PAGE_DETAILS;
export const saveThemeDetailsUrl = process.env.REACT_APP_SAVE_THEME_DETAILS;
export const getActionFlowbyAppidandPagename = process.env.REACT_APP_FETCH_ACTIONFLOW_PAGENAME;
export const getActionFlowResponse = process.env.REACT_APP_FETCH_ACTIONFLOW_RESPONSE;
export const savePageWidgetProps = process.env.REACT_APP_SAVE_PAGE_WIDGET_PROPS;
export const saveWidgetDataDtls = process.env.REACT_APP_SAVE_WIDGET_DATA_DTLS;
export const deleteWidgetDataDtls = process.env.REACT_APP_DELETE_PAGEWIDGET_PROPSWITHID;
export const saveWidthndHeightDtls = process.env.REACT_APP_SAVE_WIDTHNDHEIGHT_DTLS;
export const deletePageWidgetWithWidgetId = process.env.REACT_APP_DELETE_PAGEWIDGET_WITHWIDGETID;
export const savePageWidgetStyleDtls = process.env.REACT_APP_SAVE_WIDGET_STYLE_DTLS;
export const deletePageWidgetStyleDtls = process.env.REACT_APP_DELETE_WIDGET_STYLE_DTLS;
export const renderAppPreview = process.env.REACT_APP_PREVIEW;
export const renderTemplateAppPreview = process.env.REACT_APP_TEMPLATE;
export const getMediaAssetsListUrl = process.env.REACT_APP_FETCH_MEDIA_ASSETS_LIST;
export const defaultThemeId = process.env.REACT_APP_DEFAULT_THEME_ID;
export const getGoogleFontsApi = process.env.REACT_APP_THEME_GOOGLE_FONTS_API;
export const getThemeFontDtlsApi = process.env.REACT_APP_GET_THEME_FONT_DETAILS;
export const updateSelectedThemeIdApi = process.env.REACT_APP_UPDATE_SELECTED_THEME_ID;
export const rearrangedPageTemplateID = process.env.REACT_APP_PAGETEMPLATE_REARRANGED_PAGETEMPLEIDS;
export const rearrangedSectionTemplateID = process.env.REACT_APP_SECTIONTEMPLATE_REARRANGED_IDS;
export const rearrangedPageTemplateGroupID = process.env.REACT_APP_PAGETEMPLATE_REARRANGED_IDS;
export const advancedWidgetsAuthorizedID = process.env.REACT_APP_ADVANCED_WIDGETS_AUTHORIZED_IDS;
export const templateAuthorisedID = process.env.REACT_APP_TEMPLATE_AUTHORISED_IDS;
export const updateWidgetContainer = process.env.REACT_APP_UPDATE_PAGE_WIDGET_CONTAINER;
export const updateDeviceType = process.env.REACT_APP_UPDATE_DEVICE_TYPE;
export const pixaBayUrl = process.env.REACT_APP_PIXABAY_URL;
export const pixaBaySecretKey = process.env.REACT_APP_PIXABAY_SECRET_KEY;
export const keyClockEndPoint = process.env.REACT_APP_IAM_API_ENDPOINT;
export const testingUrl = process.env.REACT_APP_TESTING_URL;
export const testUrl = process.env.REACT_APP_TEST_URL;
export const mediaApplCtgryCommon = process.env.REACT_APP_MEDIA_APPL_CTGRY_COMMON;
export const getMediaBucketPath = process.env.REACT_APP_MEDIA_BUCKET_PATH;
export const createPageCopy = process.env.REACT_APP_PAGE_COPY;
export const copyPageWidgetDtls = process.env.REACT_APP_COPY_WIDGET_DTLS;
export const undoUserAction = process.env.REACT_APP_UNDO_USER_ACTIONS;
export const redoUserAction = process.env.REACT_APP_REDO_USER_ACTIONS;
export const pageReorderingUrl = process.env.REACT_APP_PAGES_REORDERING;
export const updateAppSpec = process.env.REACT_APP_UPDATE_APP_SPEC_VALUE;
export const updateAppTitleFavicon = process.env.REACT_APP_UPADATE_APP_TITLE_FAVICON;
export const validateFreeDomaiName = process.env.REACT_APP_VAIDATE_FREE_DOMAINNAME;
export const defaultSurfixValForFreeDomain = process.env.REACT_APP_DEFAULT_SURFIX_FREEDOMAIN;
export const studioGtmId=process.env.REACT_APP_GTM_ID;
export const workspacetour = process.env.REACT_APP_WORKSPACETOUR;
export const getfeebackQuestions=process.env.REACT_APP_GET_FEEDBACK_qUESTION
export const saveFeedbackAnswer=process.env.REACT_APP_SAVE_FEEDBACK_ANSWER
export const enableFeedbackPopup=process.env.REACT_APP_FEEDBACK_POPUP
export const logLevel=process.env.REACT_APP_LOG_LEVEL
export const updatePageImagebgimage=process.env.REACT_APP_UPDATEPAGEBGIMAGE
export const getapptemplatebygroupname=process.env.REACT_APP_GET_APP_TEMPLATE_BY_GROUP_NAME
export const searchapplicationtemplate=process.env.REACT_APP_SEARCH_APPLICATION_TEMPLATE
export const getAppTemplatesforworkspace=process.env.REACT_APP_GET_APP_TEMPLATES_FOR_WORKSPACE
export const getapptemplatebygroupnameforworkspace=process.env.REACT_APP_GET_APP_TEMPLATE_BY_GROUPNAME_FOR_WORKSPACE
export const getSvgContent=process.env.REACT_APP_GET_SVG_CONTENT
export const savepagewidgetvalidationdtls=process.env.REACT_APP_SAVE_PAGE_WIDGET_VALIDATION_DTLS
export const deletepagewidgetvalidationdtls=process.env.REACT_APP_DELETE_PAGE_WIDGET_VALIDATION_DTLS
export const saveOtherWidgetStyleDtls=process.env.REACT_APP_SAVE_OTHERWIDGET_STYLEDTLS
export const previewBaseUrl=process.env.REACT_APP_STUDIO_PREVIEW_BASE_URL
export const searchViewAllPageSectionTemplate=process.env.REACT_APP_SEARCH_VIEW_ALL_PAGE_SECTION_TEMPLATE
export const templatecategorydtl=process.env.REACT_APP_GET_TEMPLATE_CATEGORY_DTLS
export const updateapplicationtemplateinfo=process.env.REACT_APP_UPDATE_APP_TEMPLATE_INFO
export const getapptemplatebycategory=process.env.REACT_APP_GET_APP_TEMPLATE_INFO
export const updateReusableAction=process.env.REACT_APP_UPDATE_REUSABLEACTION;
export const getAllReusableAction=process.env.REACT_APP_GET_ALL_REUSABLE_ACTIONS;
export const deleteReusableAction=process.env.REACT_APP_DELETE_REUSABLE_ACTION;
export const getpagedtlsbyapplicationidforimport=process.env.REACT_APP_GET_PAGEDTLS_BY_APPLICATIONID_FOR_IMPORT
export const resetwidgetrspnvalforwidget = process.env.REACT_APP_RESETWIDGET_RSPNVAL_FOR_WIDGET
export const pageimport =process.env.REACT_APP_PAGE_IMPORT
export const getcookiessettingsdatabyappid = process.env.REACT_APP_GET_COOKIES_SETTINGS;
export const savecookiessettingsdata = process.env.REACT_APP_SAVE_COOKIES_SETTINGS;
export const deletecookiessettingsdata = process.env.REACT_APP_DELETE_COOKIES_SETTINGS;
/*Subscription Keys*/
export const subscriptionmanagementpaymentkey=process.env.REACT_APP_RAZORPAY_KEY;
export const searchPageReusableWidgetInfo=process.env.REACT_APP_SEARCH_PAGE_REUSABLE_WIDGET_INFO
export const getPageReusableWidgetInfoByAppid=process.env.REACT_APP_GET_PAGE_RESUABLE_WIDGET_INFO_BY_APP_ID
export const getaccountdetailsforinvoicegeneration=process.env.REACT_APP_GET_ACCOUNT__DETAILS_FOR_INVOICE_GENERATION
export const generateinvoicedryrun=process.env.REACT_APP_GENERATE_INVOICE_DRYRUN
export const generatefutureinvoice=process.env.REACT_APP_GENERATE_FUTURE_INVOICE
export const stripePublishablekey=process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const updatePagePropsSpecVal=process.env.REACT_APP_UPDATE_PAGE_PROPS_SPEC_VAL;
export const getPackageDtlsForWorkspace=process.env.REACT_APP_GET_PACKAGE_DTLS_FOR_WORKSPACE;
export const addPackageFromPackageDataDtls=process.env.REACT_APP_ADD_PACKAGE_FROM_PACKAGE_DATA_DTLS;
export const defOrderedPackageGroupName=process.env.REACT_APP_DEF_ORDERED_PACKAGE_GROUPNAME;
export const searchPackageDataDtls=process.env.REACT_APP_SEARCH_PACKAGE_DATA_DTLS;
export const getCategoryLevelThreeList=process.env.REACT_APP_GET_CATEGORY_LEVEL_THREE_LIST;
export const businessTypeForStrctData=process.env.REACT_APP_BUSINESS_TYPE_FOR_STRCT_DATA;
export const razorpayPaymentKey=process.env.REACT_APP_RAZORPAY_PAYMENT_KEY;
export const downloadReceipt=process.env.REACT_APP_DOWNLOAD_PAYMENT_RECEIPT;
